import { Component, OnDestroy, OnInit } from '@angular/core';
import { AlertService } from '@app/@core/services/alert.service';
import { AppService } from '@app/@core/services/app.service';
import { AuthService } from '@app/@core/services/auth.service';
import { HttpService } from '@app/@core/services/http.service';
import { SharedService } from '@app/@core/services/shared.service';
import { PermissionStore } from '@app/@core/store/permission.store';
import { BehaviorSubject, Subscription } from 'rxjs';
import { LocalService } from '@core/services/local.service';
import { environment } from 'src/environments/environment';
import { DropdownDatasourceService } from './dropdown-datasource/dropdownDatasource.service';


@Component({
  standalone: false,
  selector: 'app-dynamic',
  templateUrl: './dynamic.component.html',
  styleUrls: ['./dynamic.component.scss']
})
export class DynamicDataComponent implements OnDestroy {
  RBACORG: any;
  PERMISSION: any;
  orgSubs: Subscription;
  dynamic$: BehaviorSubject<any>;
  // INPUTVALIDATIONMETHOD: any;
  constructor(private permissionStore: PermissionStore,
    private authService: AuthService,
    private httpService: HttpService,
    private alertService: AlertService,
    private appService: AppService,
    private sharedService: SharedService,
     private sessionStorage: LocalService,
    private dropdownDatasourceService: DropdownDatasourceService
  ) {
    console.log('DYNAMIC-COMPONENTS');
    this.dynamic$ = new BehaviorSubject<any>(null);
    this.orgSubs = this.authService.orgInfo.subscribe(o => {
      this.PERMISSION = this.permissionStore.state;
      this.RBACORG = {
        tokenKey: 'jwt-token',
        apiHost: environment.apiHost,
        others: this.sessionStorage.asStorage(),
        orgID: o ? o : this.sessionStorage.getItem('orgid'),
        environment: {
          mstrUsername: environment.mstrUsername,
          mstrPassword: environment.mstrPassword,
          mstrURL: environment.mstrURL,
          mstrProjectID: environment.mstrProjectID,
          applicationid: environment.applicationid,
          priority: environment.priority,
          videoConferenceDomain: environment.videoConferenceDomain,
          ChatBotNew: environment.ChatBotNew,
          ChatBot: environment.ChatBot,
          n8nWorflowUrl: environment.n8nWorflowUrl,
          production: environment.production
        }
      };
      this.dynamic$.next({
        RBACORG: this.RBACORG,
        PERMISSION: this.PERMISSION,
        HTTPSERVICE: this.httpService,
        ALERTSERVICE: this.alertService,
        APPSERVICE: this.appService,
        SHAREDSERVICE: this.sharedService,
        DROPDOWNDATASOURCESERVICE: this.dropdownDatasourceService
      });
    });
  }

  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  ngOnDestroy(): void {
    this.orgSubs.unsubscribe();
  }
}
